
import { Vue, Component, Prop,Watch } from "vue-property-decorator";
import { BaseVue } from "@newview/base-web";
import {  } from "@newview/ui";
@Component({
  name: "",
  components: {
    
  },
})
export default class BusinessClass extends BaseVue {
  mounted() {
  }
}
